export default ["news", "offer", "recommended"];
